import type { SerializedPerson, SerializedPersonWithPhotoUrl } from '@enmon/commons/lib/tools';
import { Space } from 'antd';
import { useState, type VFC } from 'react';
import { Button, Card, PageHeader } from 'components';
import { usePersons } from 'api/hooks/person/useFind';
import { usePersonsFilterWithPagination } from './hooks/usePersonsFilterWithPagination';
import { PersonsTable } from './components/Table';
import { PersonModal } from './components/Modal';
import { Icon } from '@/components/icon';

export const PersonsPage: VFC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [person, setPerson] = useState<SerializedPerson>(undefined);

  const { filter, pagination, setPaginationState } = usePersonsFilterWithPagination();

  const {
    data: { data: persons } = {},
    isFetching: isLoading,
    refetch,
  } = usePersons(
    { sort: filter.sort, page: pagination.current, pageSize: pagination.pageSize },
    {
      onSuccess: response => {
        setPaginationState({
          total: response?.meta?.pagination?.total ?? 0,
        });
      },
    },
  );

  const handleEdit = (personForEdit: SerializedPersonWithPhotoUrl) => {
    setIsModalOpen(true);
    setPerson(personForEdit);
  };

  const handleHide = () => {
    setIsModalOpen(false);
    setPerson(undefined);
  };

  const handleSuccess = () => {
    refetch();
    handleHide();
  };

  return (
    <>
      {isModalOpen && <PersonModal person={person} onClose={handleHide} onSuccess={handleSuccess} />}
      <Space className="w-100" direction="vertical">
        <PageHeader
          extra={
            <Button icon={<Icon iconString="plus" />} type="primary" onClick={() => setIsModalOpen(true)}>
              Add new person
            </Button>
          }
          ghost={false}
          title="Persons"
        />
        <Card>
          <PersonsTable data={persons} isLoading={isLoading} onEdit={handleEdit} onSuccess={refetch} />
        </Card>
      </Space>
    </>
  );
};
